module.exports = __webpack_public_path__ + "img/icon_done_w.1eaf7a02.svg";